"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ModalContainer = _interopRequireDefault(require("../../components/common/ModalContainer"));

var _LoadSpinner = require("./message/LoadSpinner");

var _ConfirmationModal = require("./message/ConfirmationModal");

var _MobxMessageContainer = _interopRequireDefault(require("./message/MobxMessageContainer"));

var _SiteFooter = _interopRequireDefault(require("./navigation/SiteFooter"));

var _SessionExpiringModalView = _interopRequireDefault(require("../../components/session/SessionExpiringModalView"));

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _constants = require("../../util/constants");

var _environmentUtilities = _interopRequireDefault(require("../../util/environmentUtilities"));

var _MouseflowIdentifier = _interopRequireDefault(require("./mouseflow/MouseflowIdentifier"));

var _Disclaimers = _interopRequireDefault(require("../../member/components/shared/Disclaimers"));

var _class, _class2, _descriptor, _class3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var MobxPageContent = (0, _mobxReact.observer)(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
  _inherits(MobxPageContent, _React$Component);

  var _super = _createSuper(MobxPageContent);

  function MobxPageContent() {
    var _this;

    _classCallCheck(this, MobxPageContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_assertThisInitialized(_this), "hasError", _descriptor, _assertThisInitialized(_this));

    return _this;
  }

  _createClass(MobxPageContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.dispatcher.emit("LOAD_SESSION_DATA");
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.hasError = true;
    }
  }, {
    key: "_renderErrorMessage",
    value: function _renderErrorMessage() {
      var _this$props$session, _this$props$session$s, _this$props$session2;

      if (_environmentUtilities.default.isProdIntra(this.props.session)) {
        return /*#__PURE__*/_react.default.createElement("h1", {
          className: "js-error"
        }, "Oops, there was an error!");
      }

      var isMemberPortal = (_this$props$session = this.props.session) === null || _this$props$session === void 0 ? void 0 : (_this$props$session$s = _this$props$session.siteFooterModel) === null || _this$props$session$s === void 0 ? void 0 : _this$props$session$s.isMemberPortal;
      var isLoggedIn = (_this$props$session2 = this.props.session) === null || _this$props$session2 === void 0 ? void 0 : _this$props$session2.isLoggedIn; // eslint-disable-next-line no-nested-ternary

      var contactUrl = !isLoggedIn ? _constants.URLS.MARKETING.CONTACT : isMemberPortal ? _constants.URLS.MEMBER.CONTACT : _constants.URLS.EMPLOYER.CONTACT;
      return /*#__PURE__*/_react.default.createElement("h1", {
        className: "js-error"
      }, "Oops, there was an error! Please ", /*#__PURE__*/_react.default.createElement("a", {
        href: contactUrl
      }, "contact"), " customer service.");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$session3, _this$props$session$u, _this$props$session4, _this$props$footer;

      return /*#__PURE__*/_react.default.createElement("div", {
        id: "view",
        className: this.props.className
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "flash-page-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_MobxMessageContainer.default, {
        type: "flash"
      })), this.props.header ? this.props.header : null, /*#__PURE__*/_react.default.createElement("div", {
        className: "site-content"
      }, ((_this$props$session3 = this.props.session) === null || _this$props$session3 === void 0 ? void 0 : _this$props$session3.isLoggedIn) && /*#__PURE__*/_react.default.createElement(_MouseflowIdentifier.default, {
        user: (_this$props$session$u = (_this$props$session4 = this.props.session) === null || _this$props$session4 === void 0 ? void 0 : _this$props$session4.user) !== null && _this$props$session$u !== void 0 ? _this$props$session$u : {}
      }), this.props.navigation, /*#__PURE__*/_react.default.createElement("main", {
        className: "content"
      }, this.hasError ? this._renderErrorMessage() : this.props.children)), this.props.disclaimers && /*#__PURE__*/_react.default.createElement(_Disclaimers.default, {
        disclaimers: this.props.disclaimers
      }), (_this$props$footer = this.props.footer) !== null && _this$props$footer !== void 0 ? _this$props$footer : /*#__PURE__*/_react.default.createElement(_SiteFooter.default, null), /*#__PURE__*/_react.default.createElement(_SessionExpiringModalView.default, null), /*#__PURE__*/_react.default.createElement(_ModalContainer.default, null), /*#__PURE__*/_react.default.createElement(_LoadSpinner.LoadingOverlay, null), /*#__PURE__*/_react.default.createElement(_ConfirmationModal.ConfirmationModal, null));
    }
  }]);

  return MobxPageContent;
}(_react.default.Component), _defineProperty(_class3, "propTypes", {
  header: _propTypes.default.object,
  navigation: _propTypes.default.object,
  footer: _propTypes.default.object,
  className: _propTypes.default.string,
  disclaimers: _propTypes.default.string
}), _class3), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "hasError", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class;

var _default = (0, _Propulator.default)(MobxPageContent, {
  sessionStore: ["session"],
  contentStore: ["content"]
});

exports.default = _default;